import Card from '@talkdesk/cobalt-react-card'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import { Icon } from '@talkdesk/cobalt-react-icon'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'
import { MFA } from '../../constants/steps'
import { useTranslation } from 'react-i18next'
import { RECOVERY_OTP, TOTP, WEB_AUTHN } from 'mfa'

const getMFAInfoFromType = (mfaType, theme, t) => {
  return {
    [WEB_AUTHN]: {
      name: t('mfaSelector.webAuthnName'),
      description: t('mfaSelector.webAuthnDescription'),
      icon: 'security_key',
      color: theme.primary600,
    },
    [TOTP]: {
      name: t('mfaSelector.totpName'),
      description: t('mfaSelector.totpDescription'),
      icon: 'phonelink_lock',
      color: theme.green600,
    },
    [RECOVERY_OTP]: {
      name: t('mfaSelector.recoveryOtpName'),
      description: t('mfaSelector.recoveryOtpDescription'),
      icon: 'vpn_key',
      color: theme.orange600,
    },
  }[mfaType.toUpperCase()]
}

const MFACard = ({ mfaType, selectMFA, changeStep }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const mfaInfo = getMFAInfoFromType(mfaType, theme, t)

  return (
    <Box paddingBottom={2}>
      <Card
        onClick={() => {
          selectMFA(mfaType)
          changeStep(MFA)
        }}
      >
        <Flex padding={4} alignY='center' alignX='space-between'>
          <Flex alignY='center' gap={3}>
            <Icon name={mfaInfo.icon} size='medium' color={mfaInfo.color} />
            <Flex direction='column'>
              <Heading level={5}>{mfaInfo.name}</Heading>
              <Text color={theme.gray600}>{mfaInfo.description}</Text>
            </Flex>
          </Flex>
          <Icon name='chevron_right' size='small' color={theme.gray400} />
        </Flex>
      </Card>
    </Box>
  )
}

export default MFACard
